"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YAMLParser = void 0;
var js_yaml_1 = __importDefault(require("js-yaml"));
var fs_1 = __importDefault(require("fs"));
var SyntaxChecker_1 = require("./SyntaxChecker");
var ProcessBuilder_1 = require("./ProcessBuilder");
var YAMLParser = (function () {
    function YAMLParser(PassedBy, YamlRef, encoding) {
        if (encoding === void 0) { encoding = 'utf8'; }
        this._error = null;
        switch (PassedBy) {
            case 'uri':
                try {
                    YamlRef = fs_1.default.readFileSync(YamlRef, encoding);
                }
                catch (e) {
                    this._error = "Error reading file/url ".concat(YamlRef, " (").concat(e.message, ")");
                    console.log(this._error);
                }
                break;
            case 'content':
                break;
        }
        if (this.GotError)
            return;
        try {
            this._yaml = js_yaml_1.default.load(YamlRef);
        }
        catch (e) {
            this._error = "YAML file formally incorrect (".concat(e.message, ")");
            console.log(this._error);
        }
        if (this.GotError)
            return;
        try {
            var SC = new SyntaxChecker_1.SyntaxChecker(this._yaml);
            var SC_result = SC.Check();
            if (SC_result !== true)
                throw new Error(SC_result);
            this._nodeIds = SC.nodeIds;
        }
        catch (e) {
            this._error = "BPMNator syntax error:\n\n(".concat(e.message, ")");
            console.log(this._error);
        }
        if (this.GotError)
            return;
        try {
            var PB = new ProcessBuilder_1.ProcessBuilder(this._yaml);
            this._process = PB.Builder(this._nodeIds);
        }
        catch (e) {
            this._error = "Process buidler error:\n\n(".concat(e.message, ")");
            console.log(this._error);
        }
        if (this.GotError)
            return;
    }
    Object.defineProperty(YAMLParser.prototype, "GotError", {
        get: function () { return this._error !== null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YAMLParser.prototype, "NoError", {
        get: function () { return !this.GotError; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YAMLParser.prototype, "RawYaml", {
        get: function () { return this._yaml; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YAMLParser.prototype, "Error", {
        get: function () { return this._error; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YAMLParser.prototype, "Process", {
        get: function () { return this._process; },
        enumerable: false,
        configurable: true
    });
    return YAMLParser;
}());
exports.YAMLParser = YAMLParser;
//# sourceMappingURL=YAMLParser.js.map